import { BffFacility, FacilityFieldsFragment } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';
import { Typography, TypographyTypeMap } from '@mui/material';
import z from 'zod';
export const findOfficeForm = {
  zipCode: {
    name: 'zipCode',
    label: 'ZIP Code',
    schema: z.string().regex(/^\d{5}$/, 'Please enter a valid ZIP code')
  }
};
export const findOfficeFormSchema = [{
  name: findOfficeForm.zipCode.name,
  validation: findOfficeForm.zipCode.schema
}];
export const RenderDistance = (facility: BffFacility | FacilityFieldsFragment | null, color: TypographyTypeMap['props']['color'] = 'text.tertiary', translatedUnit = 'miles') => {
  if (!facility?.location) return null;
  if ('distance' in facility.location) {
    return <Typography variant="bodySmallBook" sx={{
      color
    }}>
				{Math.round(Number(facility?.location?.distance))} {translatedUnit}
			</Typography>;
  }
  return null;
};